module.exports = __webpack_public_path__ + "static/media/appleQR.08d0adf8.svg";